import {
   Checkbox,
   ListItemText,
   MenuItem,
   Select,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const CustomSelectRosterSelectGroup = ({
   className = '',
   name,
   id,
   multiple = false,
   value = multiple ? [] : '',
   onChange = () => { },
   options,
   dataType,
   defaultValue,
   readOnly,
   position,
   onRemoveItem,
}) => {
   const { t } = useTranslation();
   const language = useSelector((state) => state.languageR.language);
   const containerRef = React.useRef(null);
   const [isMultiline, setIsMultiline] = React.useState(false);

   React.useEffect(() => {
      const el = containerRef.current;
      if (!el) return;

      // scrollHeight > clientHeight => có overflow => đã xuống dòng
      setIsMultiline(el.scrollHeight > el.clientHeight);
   }, [value]);

   const getValue = (option) => {
      switch (dataType) {

         case 'group': return option.id;
         default: return option.value;
      }
   };

   const getLabel = (option) => {
      switch (dataType) {

         case 'group':
            // Nếu tên nhóm là "All users" → dùng i18n
            if (option.groupName?.trim().toLowerCase() === "all users") {
               return t("common.all-user");
            }
            return option.groupName;

         default:
            return option.label;
      }
   };


   const handleChange = (event) => {
      const { value } = event.target;
      onChange({
         target: {
            name,
            value: multiple
               ? typeof value === 'string'
                  ? value.split(',')
                  : value
               : value,
         },
      });
   };

   const validValue = multiple
      ? Array.isArray(value)
         ? value.filter((val) => options?.some((option) => getValue(option) === val))
         : []
      : options?.some((option) => getValue(option) === value)
         ? value
         : '';

   return (
      <Select
         multiple={multiple}
         name={name}
         id={id}
         value={validValue}
         onChange={handleChange}
         defaultValue={defaultValue || null}
         displayEmpty
         readOnly={readOnly}
         className={`form-control ${className}`}
         MenuProps={{
            anchorOrigin: {
               vertical: position === 'top' ? 'top' : 'bottom',
               horizontal: 'left',
            },
            transformOrigin: {
               vertical: position === 'top' ? 'bottom' : 'top',
               horizontal: 'left',
            },
            PaperProps: {
               style: { maxHeight: 240 },
            },
         }}
         sx={{
            ...(dataType === 'group' && {
               backgroundColor: '#fff !important',
               border: '1px solid #E5E7EB !important',
               borderRadius: '6px !important',
               height: 'auto',
               padding: validValue?.length >= 3 ? '6px 8px !important' : '0 8px 0 8px',
               minHeight: '40px',
               maxHeight: 'none',
               overflowY: isMultiline ? 'auto' : 'hidden',
               boxSizing: 'border-box',
               '&.MuiInputBase-root': {
                  height: 'auto !important',
                  alignItems: 'flex-start', // cực kỳ quan trọng
               },
               '& .MuiOutlinedInput-notchedOutline': {
                  display: 'none !important',
               },
               '& .MuiSelect-icon': {
                  display: 'none !important',
               },
               '& .MuiSelect-nativeInput': {
                  display: 'none !important',
               },
               '& .MuiSelect-select': {
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '8px',
                  alignItems: 'flex-start',
                  maxHeight: '100%',
                  overflowY: validValue?.length >= 3 ? 'auto' : 'hidden',
                  pr: '0 !important',
                  pl: '5px !important',
                  paddingTop: validValue?.length >= 3 ? '8px' : '8px',
                  paddingBottom: '8px',
                  boxSizing: 'border-box',
                  paddingRight: '5px',
                  /* 🔥 Ẩn scrollbar */
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
               },
               '&.MuiInputBase-readOnly': {
                  height: '40px !important',
                  borderRadius: '6px !important',
                  border: '1px solid #E5E7EB !important',
                  backgroundColor: '#fff !important',
               },
               // Bỏ hiệu ứng hover/focus
               '&:hover, &.Mui-focused': {
                  border: '1px solid #E5E7EB !important',
                  boxShadow: 'none !important',
               },
            })
         }}
         // sx={{
         //    backgroundColor: '#fff !important',
         //    border: '1px solid #E5E7EB !important',
         //    borderRadius: '6px !important',
         //    height: value?.length > 8
         //       ? '240px !important'
         //       : value?.length > 6
         //          ? '190px !important'
         //          : value?.length > 4
         //             ? '155px !important'
         //             : value?.length >= 3
         //                ? '110px !important'
         //                : '40px !important',
         //    padding: value?.length >= 3 ? '6px 8px !important' : '0 8px 0 8px',
         //    minHeight: '40px !important',
         //    boxSizing: 'border-box',

         //    '& .MuiOutlinedInput-notchedOutline': {
         //       display: 'none !important',
         //    },
         //    '& .MuiSelect-icon': {
         //       display: 'none !important',
         //    },
         //    '& .MuiSelect-nativeInput': {
         //       display: 'none !important',
         //    },
         //    '& .MuiSelect-select': {
         //       display: 'flex',
         //       flexWrap: 'wrap',
         //       gap: '8px',
         //       alignItems: 'flex-start',
         //       maxHeight: '100%',
         //       overflowY: value?.length >= 3 ? 'auto' : 'hidden',
         //       pr: '0 !important',
         //       paddingTop: value?.length >= 3 ? '8px' : '0',
         //       paddingBottom: '8px',
         //       boxSizing: 'border-box',
         //       paddingRight: '5px'
         //    },
         //    '&.MuiInputBase-readOnly': {
         //       height: '40px !important',
         //       borderRadius: '6px !important',
         //       border: '1px solid #E5E7EB !important',
         //       backgroundColor: '#fff !important',
         //    }
         // }}
         renderValue={(selected) => {
            if (Array.isArray(selected)) {
               const selectedLabels = selected
                  .map((val) => {
                     const foundOption = options.find((option) => getValue(option) === val);
                     return foundOption
                        ? { value: getValue(foundOption), label: getLabel(foundOption) }
                        : null;
                  })
                  .filter(Boolean);

               return (
                  <div
                     ref={containerRef}
                     style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                        maxHeight: 200,
                        overflowY: 'auto',
                     }}
                  >
                     {selectedLabels.map(({ value: val, label }, idx) => (
                        <div
                           key={idx}
                           style={{
                              display: 'flex',
                              alignItems: 'center',
                              backgroundColor: '#fff',
                              padding: '0 8px 0 12px',
                              height: '32px',
                              borderRadius: '8px',
                              fontSize: '0.875rem',
                              border: '1px solid #E5E7EB',
                           }}
                        >
                           <span style={{ marginRight: '8px' }}>{label}</span>
                           <span
                              onMouseDown={(e) => e.stopPropagation()} // ✅ Ngăn Select mở
                              onClick={(e) => {
                                 e.stopPropagation(); // ✅ Ngăn lan ra ngoài
                                 const newSelected = selected.filter((item) => item !== val);
                                 onChange({
                                    target: {
                                       name,
                                       value: newSelected,
                                    },
                                 });
                                 // ✅ Gọi thêm hàm nếu cần thông báo ra ngoài:
                                 if (onRemoveItem) onRemoveItem(val);
                              }}
                              style={{
                                 cursor: 'pointer',
                                 display: 'flex',
                                 alignItems: 'center',
                                 justifyContent: 'center',
                                 width: '20px',
                                 height: '20px',
                                 borderRadius: '50%',
                                 backgroundColor: '#EAECF0',
                                 color: '#fff',
                                 fontWeight: 'bold',
                                 fontSize: '14px',
                                 lineHeight: 1,
                              }}
                           >
                              ×
                           </span>
                        </div>
                     ))}
                  </div>
               );
            }

            const foundOption = options.find((option) => getValue(option) === selected);
            return foundOption ? getLabel(foundOption) : selected;
         }}
      >
         {options?.map((option, index) => (
            <MenuItem
               key={index}
               value={getValue(option)}
               disableRipple
               sx={{
                  "&:hover, &.Mui-focused, &.Mui-selected, &.Mui-selected:hover, &.Mui-focusVisible": {
                     backgroundColor: "transparent !important",
                  },
               }}
            >
               {multiple && (
                  <Checkbox checked={value.indexOf(getValue(option)) > -1} />
               )}
               <ListItemText primary={getLabel(option)} />
            </MenuItem>
         ))}
      </Select>
   );
};

export default CustomSelectRosterSelectGroup;
